import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SOCKET_CHAT_EVENT,
  SOCKET_DISCUSSION_EVENTS,
  SOCKET_NAMESPACE,
} from 'constants/constants';
import Socket from 'helpers/socket';
import { SOCKET_URL } from 'config';
import {
  setGroupUnread,
  setMessage,
  setOnlineChange,
  setUpdatedGroup,
  setUpdateUnread,
  setUserUnread,
} from 'store/messages';
import { setUpdateSocket } from 'store/discussion';
import { useShouldDisconnectSocket, useUser } from './index';
import { PREVIOUS_ROLEID } from 'helpers/storage';

export const useSocket = (namespace = '', params = {}) => {
  const auth = useUser();
  const [previousRoleId, setPreviousRoleId] = useState();

  const socket = new Socket(SOCKET_URL + namespace);
  const dispatch = useDispatch();
  const shouldDisconnect = useShouldDisconnectSocket();

  function listenEventByNamespace() {
    switch (namespace) {
      case SOCKET_NAMESPACE.CHAT:
        // Listen event Chat
        socket.on(SOCKET_CHAT_EVENT.MESSAGE, (event) => {
          if (event?._id) {
            if (event?.sender?._id) {
              event.sender.online = true;
            }
            dispatch(setMessage(event));
            if (event?.sender?._id && event.sender._id !== auth?._id) {
              dispatch(setUpdateUnread(event));
            }
          }
        });
        socket.on(SOCKET_CHAT_EVENT.USER_ONLINE_STATE_CHANGE, (event) => {
          let params = {
            ...event,
            ...(previousRoleId && { adminid: previousRoleId }),
          };
          socket.userStateChange(params);
          dispatch(setOnlineChange(params));
        });
        socket.on(SOCKET_CHAT_EVENT.USER_UNREAD_MESSAGE_NUM, (event) => {
          if (typeof event?.unreadMessage === 'number') {
            dispatch(setUserUnread(event?.unreadMessage));
          }
        });
        socket.on(SOCKET_CHAT_EVENT.GROUP_UNREAD_MESSAGE_NUM, (event) => {
          dispatch(setGroupUnread(event));
        });
        socket.on(SOCKET_CHAT_EVENT.GROUP_CHAT_UPDATE, (event) => {
          dispatch(setUpdatedGroup(event));
        });
        break;
      case SOCKET_NAMESPACE.DISCUSSION:
        // Listen event Discussion
        socket.on(SOCKET_DISCUSSION_EVENTS.DISCUSSION, (event) => {
          dispatch(
            setUpdateSocket({
              type: SOCKET_DISCUSSION_EVENTS.DISCUSSION,
              data: event,
              time: Date.now(),
            }),
          );
        });
        socket.on(SOCKET_DISCUSSION_EVENTS.DISCUSSION_UPDATED, (event) => {
          dispatch(
            setUpdateSocket({
              type: SOCKET_DISCUSSION_EVENTS.DISCUSSION_UPDATED,
              data: event,
              time: Date.now(),
            }),
          );
        });
        socket.on(SOCKET_DISCUSSION_EVENTS.DISCUSSION_DELETED, (event) => {
          dispatch(
            setUpdateSocket({
              type: SOCKET_DISCUSSION_EVENTS.DISCUSSION_DELETED,
              data: event,
              time: Date.now(),
            }),
          );
        });
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    setPreviousRoleId(PREVIOUS_ROLEID.get());
  }, []);

  const handleConnectSocket = () => {
    try {
      socket.connect(params);

      // Listen event connection
      socket.on('connect', () => {
        // Todo: event connect
        console.log('socket connected');
      });

      // Listen event by namespace
      listenEventByNamespace();

      // Listen event disconnect
      socket.on('disconnected', () => {
        console.log('socket disconnected');
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDisconnectSocket = () => {
    try {
      if (
        typeof socket?.disconnect === 'function' &&
        socket?.socket?.connected
      ) {
        console.log('disconnect socket');
        socket.disconnect();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?._id) {
      handleConnectSocket();
    }
  }, [auth?._id]);

  useEffect(() => {
    if (shouldDisconnect) {
      handleDisconnectSocket();
    }
  }, [shouldDisconnect]);

  useEffect(() => () => handleDisconnectSocket(), []);
};
